import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro'
import MarketingStrategies from './MarketingStrategies'
import WhyMarketing from './WhyMarketing'
import Footer from '../../components/Footer'



export const Home = () => {
  return (
    <Layout>
    <div className=''>
        <Intro />
      <MarketingStrategies />
      <WhyMarketing />
    </div>
    <Footer/>
    </Layout>
  )
}
export default Home